import { getUserConfiguration } from 'owa-session-store';

let userType = null;
let isConsumer = false;
if (typeof location !== 'undefined') {
    isConsumer = location.hostname && location.hostname.indexOf('live.com') > -1;
}

export default function(): string {
    if (!userType) {
        var userConfiguration = getUserConfiguration();
        if (userConfiguration) {
            if (userConfiguration.IsConsumerChild) {
                userType = 'c_child';
            } else if (userConfiguration.SessionSettings.IsPremiumConsumerMailbox) {
                userType = 'c_premium';
            } else if (userConfiguration.SessionSettings.IsShadowMailbox) {
                userType = 'c_shadow';
            } else if (isConsumer) {
                userType = 'c_standard';
            } else {
                userType = 'business';
            }
        }
    }

    return userType;
}
